import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import BadgeDownload, { DownloadType } from 'components/BadgeDownload';
import { AutoFormatMessage } from 'common/libs/intl';
import messages from './FooterDownloadApp.messages';
import styles from './FooterDownloadApp.module.scss';

class FooterDownloadApp extends React.PureComponent<WrappedComponentProps> {
  render() {
    const locale = this.props.intl.locale;
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <p><AutoFormatMessage message={messages.title} /></p>
          <div className={styles.badgeWrapper}>
            <BadgeDownload locale={locale} className={styles.badge} downloadType={DownloadType.apple}/>
            <BadgeDownload locale={locale} className={styles.badge} downloadType={DownloadType.google}/>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(FooterDownloadApp);